module.exports = __webpack_public_path__ + "img/jobs-icon.2d54d9cf.svg";